export function setCartItem(response = {}, filteredData = false) {
  console.log('Cart SetCartItem response -> ', response.entries)
  const { entries: cartItem = [], consignmentsData = [] } = response;
  const { entries: consignmentEntries = [] } = consignmentsData.length >0 ? consignmentsData[0] : {};
  console.log("TRACK POINT 5 ~ cartItem:", cartItem)

  let formattedCartItem = [];
  if (cartItem.length > 0) {
    let giftFilteredData = []
    if(!filteredData)
    { 
      giftFilteredData = cartItem
   } else {
      giftFilteredData = cartItem.filter(item => !item.isGiftProduct)
    }
    formattedCartItem = giftFilteredData.map((item, index) => {
      let itemObj = {};

      // NOTE: FOR GIFT WITH PURCHASE - POST ORDER - RETURN CREATION FLOW - STEP 2
      const doesItemHasGifts = consignmentEntries.find(
        entry =>
          entry?.orderEntry?.product?.code === item?.product?.code && entry?.orderEntry?.giftProducts
      );
      if (doesItemHasGifts) {
        itemObj = {
          ...itemObj,
          giftProducts: doesItemHasGifts?.orderEntry?.giftProducts
        };
      }

      if (
        item.hasOwnProperty('voucherMessages') ||
        (item.hasOwnProperty('voucherPromoAmt') && item.voucherPromoAmt <= 0)
      ) {
        itemObj = {
          ...itemObj,
          voucherMessages: 'Not Applicable'
        };
      }

      if (item.hasOwnProperty('voucherPromoAmt') && item.voucherPromoAmt > 0) {
        itemObj = {
          ...itemObj,
          voucherMessages: 'Applied'
        };
      }

      if (item.hasOwnProperty('best price')) {
        itemObj = {
          ...itemObj,
          voucherMessages: "Product is at it's best price."
        };
      }

      if (
        item.hasOwnProperty('voucherMessages') &&
        item.voucherMessages == 'Coupon not applicable:'
      ) {
        itemObj = {
          ...itemObj,
          voucherMessages: 'Not Applicable'
        };
      }

      const {
        basePrice = {},
        entryNumber = index,
        voucherPromoAmt = 0,
        quantity = 0,
        totalPrice = {},
        isGiftProduct = false,
        product: {
          baseOptions = [],
          availableQuantity = null,
          isReturnable = false,
          isExchangeable = false,
          returnWindow
        } = {},
        priceInfo = {},
        eddUpper,
        eddLower,
        dealEnabled,
        dealEndTime,
        dealType,
        actualDealStartTime,
        premiumDealStartTime,
        multiItemPromoAmt,
        averageRating,
        numUserRatings,
        segmentId = '',
        experimentId = '',
        giftQuantity = 0,
        giftProducts = null,
        age = 0,
        servicabilityInfo = {},
        isMembershipArticle = false,
        membershipDetails = null,
        memberShipBenefitList = [],
        tags=[],
        earn_rule_id = '',
        burn_rule_id = '',
        duration = '',
        tagsWithPosition = [],
        isGstEligible = false
      } = item;

      itemObj = {
        ...itemObj,
        basePrice,
        multiItemPromoAmt,
        entryNumber,
        voucherPromoAmt,
        quantity,
        totalPrice,
        priceInfo,
        eddUpper,
        eddLower,
        dealEnabled,
        dealEndTime,
        dealType,
        actualDealStartTime,
        premiumDealStartTime,
        availableQuantity,
        isReturnable,
        isExchangeable,
        returnWindow,
        averageRating,
        numUserRatings,
        segmentId,
        experimentId,
        isGiftProduct,
        giftQuantity,
        age,
        servicabilityInfo,
        isMembershipArticle,
        membershipDetails,
        memberShipBenefitList,
        tags,
        earn_rule_id,
        burn_rule_id,
        duration,
        tagsWithPosition,
        isGstEligible
      };
      if(!isGiftProduct && giftQuantity > 0){
        itemObj.giftProducts = item.giftProducts;
      }

      itemObj = { ...itemObj, ...setBasicInfoOfItem(item) };

      if (baseOptions.length > 0) {
        itemObj = {
          ...itemObj,
          ...setOtherBasicInfo(baseOptions),
          variantOptionQualifiers: setQualifiers(baseOptions)
        };
      }

      itemObj = {
        ...itemObj,
        offers: setProductOffers(response, entryNumber)
      };

      if (
        response.hasOwnProperty('restoredProducts') &&
        response.restoredProducts.includes(itemObj.code)
      ) {
        itemObj = {
          ...itemObj,
          isRestored: {
            code: itemObj.code,
            images: itemObj.images
          }
        };
      }
      console.log("TRACK POINT 5 ~ itemObj:", itemObj)

      return itemObj;
    });
  }
  return formattedCartItem;
}


export function setGiftItem(response = {}) {
  const { entries: giftItem = [] } = response;

  let formateedGiftItems = [];
  if (giftItem.length > 0) {
    formateedGiftItems = giftItem.filter(item => item.isGiftProduct).map((item, index) => {
      let itemObj = {};
      // I this lot of this data is not needed for the gift items
      // I have kept this in any case to avoid any unexpected bugs as data coming from backend for is 
      // same as cart item
      const {
        basePrice = {},
        entryNumber = index,
        voucherPromoAmt = 0,
        quantity = 0,
        totalPrice = {},
        product: {
          baseOptions = [],
          availableQuantity = null,
          isReturnable = false,
          isExchangeable = false,
          returnWindow
        } = {},
        priceInfo = {},
        eddUpper,
        eddLower,
        dealEnabled,
        dealEndTime,
        dealType,
        actualDealStartTime,
        premiumDealStartTime,
        multiItemPromoAmt,
        averageRating,
        numUserRatings,
        segmentId = '',
        experimentId = '',
        isGiftProduct,
        age = 0
      } = item;

      itemObj = {
        ...itemObj,
        basePrice,
        multiItemPromoAmt,
        entryNumber,
        voucherPromoAmt,
        quantity,
        totalPrice,
        priceInfo,
        eddUpper,
        eddLower,
        dealEnabled,
        dealEndTime,
        dealType,
        actualDealStartTime,
        premiumDealStartTime,
        availableQuantity,
        isReturnable,
        isExchangeable,
        returnWindow,
        averageRating,
        numUserRatings,
        segmentId,
        experimentId,
        isGiftProduct,
        age
      };
      itemObj = { ...itemObj, ...setBasicInfoOfItem(item) };

      if (baseOptions.length > 0) {
        itemObj = {
          ...itemObj,
          ...setOtherBasicInfo(baseOptions),
          variantOptionQualifiers: setQualifiers(baseOptions)
        };
      }

      itemObj = {
        ...itemObj,
        offers: setProductOffers(response, entryNumber)
      };

      if (
        response.hasOwnProperty('restoredProducts') &&
        response.restoredProducts.includes(itemObj.code)
      ) {
        itemObj = {
          ...itemObj,
          isRestored: {
            code: itemObj.code,
            images: itemObj.images
          }
        };
      }
    

      return itemObj;
    });
  }
  return formateedGiftItems;
}

/**
 * Set basic information with regards to product item like
 *  Name, brandName, code, images
 */

function setBasicInfoOfItem(item = {}) {
  const { product = {} } = item;

  let basicInfoObject = {};

  const {
    brandName = '',
    code = '',
    catalogName = '',
    brickCategory = '',
    name = '',
    wasPriceData = {},
    url = '',
    images = [],
    baseProduct = '',
    fnlColorVariantData: { productTag = '' } = {},
    verticalColor = '',
    brickName = '',
    brickSubCategory = '',
    stockInfo = {},
  } = product;
  console.log("🚀 ~ file: cartItem.js:150 ~ setBasicInfoOfItem ~ stockInfo:", stockInfo)

  basicInfoObject = {
    ...basicInfoObject,
    brandName,
    code,
    catalogName,
    brickCategory,
    name,
    wasPriceData,
    url,
    images,
    baseProduct,
    productTag,
    verticalColor,
    brickName,
    brickSubCategory,
    stockInfo
  };
  return basicInfoObject;
}

/**
 * Set other basic information with regards to item like
 *  size, exclusiveTill, color etc.
 */

function setOtherBasicInfo(baseOptions = []) {
  const info = {};
  let tempVariantQualifier = [];
  baseOptions.map((item, index) => {
    const { selected: { variantOptionQualifiers = [] } = {} } = item;
    if (variantOptionQualifiers.length > 0) {
      tempVariantQualifier = tempVariantQualifier.concat(variantOptionQualifiers);
    }
  });
  tempVariantQualifier.map((variantItem, item) => {
    const { qualifier = '', value = '' } = variantItem;
    if (
      qualifier === 'size' ||
      qualifier === 'color' ||
      qualifier === 'exclusiveTill' ||
      (qualifier === 'brandSize' && value)
    ) {
      info[qualifier] = value;
    }
  });
  tempVariantQualifier.length = 0;
  return info;
}

function setQualifiers(baseOptions = []) {
  let qualifiers = {};
  baseOptions.map(item => {
    const { selected: { variantOptionQualifiers = [] } = {}, variantType } = item;
    if (variantType === 'FnlSizeVariant') {
      qualifiers = variantOptionQualifiers;
    }
  });
  return qualifiers;
}

function setProductOffers(response = {}, entryNumber = -1) {
  let offers = {
    listVoucher: 0
  };

  /**
   *
   */
  if (response.hasOwnProperty('appliedVouchers')) {
    const { appliedVouchers = [] } = response;
    offers.listVoucher = 1;
    offers = { ...offers, appliedVouchers };
  }

  if (response.hasOwnProperty('appliedProductPromotions')) {
    const { appliedProductPromotions = [] } = response;
    const appliedPromotion = {};

    appliedProductPromotions.map((item, index) => {
      const { consumedEntries = [], description = '', promotion = {} } = item;

      consumedEntries.map((consumedEntryItem, index) => {
        const { orderEntryNumber } = consumedEntryItem;
        if (parseInt(entryNumber) === parseInt(orderEntryNumber)) {
          if (promotion.promotionType) {
            offers.listVoucher += 1;
            appliedPromotion.tier = appliedPromotion.tier ? appliedPromotion.tier : [];
            appliedPromotion.tier.push({
              description,
              promotion,
              entryNumber
            });
          } else {
            appliedPromotion.nontier = appliedPromotion.nontier ? appliedPromotion.nontier : [];
            appliedPromotion.nontier.push({
              description,
              promotion,
              entryNumber
            });
          }
          return true;
        }
      });
    });
    offers = { ...offers, appliedPromotion };
  }

  if (response.hasOwnProperty('potentialProductPromotions')) {
    const { potentialProductPromotions = [] } = response;
    const potentialPromotion = {};

    potentialProductPromotions.map((item, index) => {
      const { consumedEntries = [], description = '', promotion = {} } = item;

      consumedEntries.map((consumedEntryItem, index) => {
        const { orderEntryNumber } = consumedEntryItem;
        if (parseInt(entryNumber) === parseInt(orderEntryNumber)) {
          if (promotion.promotionType) {
            offers.listVoucher += 1;
            potentialPromotion.tier = potentialPromotion.tier ? potentialPromotion.tier : [];
            potentialPromotion.tier.push({
              description,
              promotion,
              entryNumber
            });
          } else {
            potentialPromotion.nontier = potentialPromotion.nontier
              ? potentialPromotion.nontier
              : [];
            potentialPromotion.nontier.push({
              description,
              promotion,
              entryNumber
            });
          }

          return true;
        }
      });
    });
    offers = { ...offers, potentialPromotion };
  }

  if (offers.listVoucher === 0) {
    const { appliedPromotion = {}, potentialPromotion = {} } = offers;
    offers = {
      ...offers,
      listVoucher:
        appliedPromotion.nontier && appliedPromotion.nontier.length
          ? appliedPromotion.nontier.length
          : potentialPromotion.nontier && potentialPromotion.nontier.length
          ? potentialPromotion.nontier.length
          : offers.listVoucher
    };
  }
  return offers;
}
